import { css } from "@emotion/react";

export const inputCss = css`
  width: calc(100% - 20px);
  margin: 5px 0;
`;
